import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import { useConfigurationGroupScrolling } from "../../NavigationState/useConfigurationScrolling";
import { AttributeGroupHeadline } from "./AttributeGroupHeadline";
import { useAttributeGroupExpansionState } from "./useAttributeGroupExpansionState";
export function AttributeGroupAccordion(props) {
    const { defaultIsExpanded, title } = props;
    const { isExpanded, setIsExpanded } = useAttributeGroupExpansionState({
        defaultIsOpen: defaultIsExpanded,
        groupId: title,
    });
    const groupRef = useConfigurationGroupScrolling({ groupId: title });
    return (_jsx(Box, { ref: groupRef, sx: { my: "1em" }, className: "attribute-group-accordion", children: _jsxs(Accordion, { expanded: isExpanded, onChange: (e, expanded) => setIsExpanded(expanded), slotProps: {
                transition: { unmountOnExit: true },
            }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), component: "div", children: _jsx(AttributeGroupHeadline, Object.assign({}, props)) }), _jsx(AccordionDetails, { children: props.children })] }) }));
}
//# sourceMappingURL=AttributeGroupAccordion.js.map